'use es6';

import { getRequiredOnboarding } from 'pricing-pages-lib/api/RequiredOnboardingApi';
import { createRequestTypes, createRequestActions } from './RequestActions';
import makeFetchRequest from './makeFetchRequest';
export const FetchRequiredOnboardingRequestTypes = createRequestTypes('REQUIRED_ONBOARDING');
export const FetchRequiredOnboardingActions = createRequestActions(FetchRequiredOnboardingRequestTypes);
export const fetchRequiredOnboarding = () => dispatch => {
  return makeFetchRequest({
    requestActions: FetchRequiredOnboardingActions,
    fetch: getRequiredOnboarding
  })(dispatch);
};